
import angular from 'angular';
import CarouselCategoryComponent from './carousel-category.component';

let CarouselCategoryModule = angular.module('home.carouselCategory',[])
.component('carouselCategory',CarouselCategoryComponent);
export default CarouselCategoryModule;



/** WEBPACK FOOTER **
 ** ./www/components/home/carousel-category/carousel-category.js
 **/